export const JSON_EDITOR_MODE = Object.freeze({
  FORM: 'form',
  CODE: 'code',
  TREE: 'tree'
})
